module.exports = __webpack_public_path__ + "img/wipo.117bede2.png";